import USER from '../../models/user.js';

class AuthenticationService {
  constructor(config, $http, localStorageService, userAccountService, jwtHelper, Keepalive, roleService, $q, httpDim, Idle) {
    this.config = config;
    this.$http = $http;
    this.localStorageService = localStorageService;
    this.userAccountService = userAccountService;
    this.jwtHelper = jwtHelper;
    this.keepalive = Keepalive;
    this.idle = Idle;
    this.$q = $q;
    this.httpDim = httpDim;
    this.roleService = roleService;

    if (this.userIsLoggedIn()) {
      this.setAuthHeader(this.getToken());
    }
  }

  userIsLoggedIn() {
    return (this.hasToken() && !this.isTokenExpired());
  }

  login(email, password) {
    let url = this.config.apiRoot + '/login';
    let body = {
      email: email,
      password: password
    };

    return this.$http.post(url, body).then(this.onLoginSuccess.bind(this), this.onLoginFailure.bind(this));
  }

  onLoginSuccess(res) {
    let hasData = res.data && res.data.token;
    if (hasData) {
      this.setToken(res.data.token);
      this.updateUserSessionSettings(res.data.token);
      this.setUserAccount(res.data.token);
    }
    return res;
  }

  // set the keepalive and idleTime based on the user session profile, we take sessiontime 30sec before the actual expiry to have buffer for batch polling we do every 15sec.
  updateUserSessionSettings(token, isSsoProfile = false) {
    const decodedToken = this.jwtHelper.decodeToken(token);
    const sessionDurationInSeconds = decodedToken.exp - decodedToken.iat;
    
    this.keepalive.setInterval(sessionDurationInSeconds - 30);
    
    // we only want to change the session timeout if sso user else keep it default value of 1hour.
    if(isSsoProfile) {
      this.idle.setIdle(sessionDurationInSeconds);
    } else { // explicilty restart the process for changes to be reflected.
      this.keepalive.start();
    } 
  }

  onLoginFailure(res) {
    return this.$q.reject(res);
  }

  logout() {
    let token = this.getToken();
    if (token) {
      this.clearCredentials();
    }
  }

  clearCredentials() {
    this.localStorageService.clearAll();
    this.$http.defaults.headers.common.Authorization = undefined;
  }

  hasToken() {
    let token = this.getToken();
    return (token);
  }

  getToken() {
    return this.localStorageService.get('token');
  }

  setToken(token) {
    if (token) {
      this.localStorageService.set('token', token);

      this.setAuthHeader(token);
    }
  }

  isTokenExpired() {
    let expired = true;
    let token = this.getToken();

    if (token) {
      expired = this.jwtHelper.isTokenExpired(token);
    }

    return expired;
  }

  refreshCredentials() {
    let url = this.config.apiRoot + '/refresh';
    let config = this.config;

    url = this.httpDim.appendCacheBust(url);

    if (this.userIsLoggedIn()) {
      // this calls refresh
      this.$http.get(url, config).then(this.onGetRefreshCredentialsSuccess.bind(this));
    }
  }

  setAuthHeader(token) {
    this.$http.defaults.headers.common.Authorization = 'Bearer ' + token;
  }

  onGetRefreshCredentialsSuccess(res) {
    this.setToken(res.data.token);
  }

  setUserAccount(token) {
    var userDetails = this.getUserFromToken(token);
    this.userAccountService.setUserDetailsInClientStorage(userDetails);
    this.setRole(userDetails);
  }

  setSsoUserAccount(token){
    var userDetails = this.getUserFromToken(token);
    this.userAccountService.setSsoUserDetails(userDetails);
    this.setRole(userDetails);
  }

  setRole(userDetails) {
    let role = userDetails.userType;
    let isImpersonating = userDetails.isImpersonating;

    this.roleService.setRole(role);
    this.roleService.setIsImpersonating(isImpersonating);
  }

  getUserFromToken(token) {
    var tokenPayload = this.jwtHelper.decodeToken(token);
    var tokenContent = tokenPayload.content;
    var user = angular.copy(USER);
    user.userType = tokenContent.userType;
    user.isImpersonating = tokenContent.isImpersonating;
    user.firstName = tokenContent.givenName;
    user.lastName = tokenContent.familyName;
    user.email = tokenContent.email;
    user.userId = tokenContent.id;
    user.title = tokenContent.title;
    user.phone = tokenContent.phone;
    user.customerId = tokenContent.customerId || 0;

    return user;
  }
}

AuthenticationService.$inject = ['config', '$http', 'localStorageService', 'userAccountService', 'jwtHelper', 'Keepalive', 'roleService', '$q', 'httpDim', 'Idle'];

export
default AuthenticationService;


// WEBPACK FOOTER //
// ./app/common/authentication/authentication.service.js